import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-paper" data-testid="site-layout">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
